import { M_CERT_TEMPLATES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = { success: boolean; error?: string };

export const pushMCertTemplate = (
    docid: string,
    template: {
        id?: string;
        heading: string;
        template: string;
        name: string;
        type: 'mcert' | 'consent';
    },
): Promise<Res> => {
    return fetchWithRefresh(M_CERT_TEMPLATES(docid), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ template }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to push M_CERT_TEMPLATES');
        }
    });
};

export const getMCertTemplates = (
    docid: string,
): Promise<
    Res & {
        templates: {
            id: string;
            heading: string;
            template: string;
            name: string;
            type?: 'mcert' | 'consent' | null;
        }[];
    }
> => {
    return fetchWithRefresh(M_CERT_TEMPLATES(docid)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to get M_CERT_TEMPLATES');
        }
    });
};
